module.exports = __webpack_public_path__ + "img/step3-c.221117df.png";